import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.alert;

export default class Alert extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(),
      error: this.boolean(false),
      message: this.string('Server error. Please try again later.'),
      errorTip: this.string('Please try again later.'),
      agree: this.boolean(false),
      button_ok_text: this.string('OK'),
      button_cancel_text: this.string('Cancel'),
    };
  }
}
